<template>
  <CRow class="newTemplateLists py-5">
    <CCol sm="12" class="mb-5 pb-5">
      <CRow class="">
        <CCol sm="12" class="mb-5 mt-5 pt-5">
          <div class="mb-4">
            <h1 class="titlePage font-weight-normal text-capitalize">
              {{ $t('templates.email.new-template-list.title') }}
            </h1>
          </div>
          <a
            @click="back"
            class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer text-uppercase"
          >
            <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
            <span v-if="!isDestinationTypeCampaign || !isDestinationTypeWorkflow">
              {{ $t('templates.email.new-template-list.backList') }}
            </span>
            <span v-else>
              {{ $t('templates.email.new-template-list.backCampaign') }}
            </span>
          </a>
        </CCol>
        <CCol sm="12" class="mb-4">
          <h3 class="font-weight-normal">
            {{ $t('templates.email.new-template-list.start-point.text') }}
          </h3>
        </CCol>
        <CCol sm="12">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
        <CCol sm="12">
          <h4 class="font-weight-normal">
            {{ $t('templates.email.new-template-list.option-creat') }}
          </h4>
          <ListViewtemplate :templates="options" />
        </CCol>
        <CCol sm="12" class="py-5 mb-5">
          <h4 class="font-weight-normal">
            {{ $t('templates.email.new-template-list.my-templates') }}
          </h4>
          <div style="position: relative">
            <div v-if="loadingMyTemplates" style="max-height: 300px" class="mt-5 d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
            <ListViewtemplate :templates="myTemplates" v-else />
          </div>
        </CCol>
        <CCol v-if="defaultTemplates.length > 0 && !isEmailSelection" sm="12" class="py-5 mb-5">
          <h4 class="font-weight-normal">
            {{ $t('templates.email.new-template-list.defaultTemplates') }}
          </h4>
          <div style="position: relative">
            <div v-if="loadingMyTemplates" style="max-height: 300px" class="mt-5 d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
            <ListViewtemplate :templates="defaultTemplates" v-else />
          </div>
        </CCol>
        <!-- <CCol sm="12" class="py-5 mb-5">
          <h4 class="font-weight-normal">Pre-defined templates Unlayer</h4>
          <div style="position: relative">
            <div
              v-if="loadingUnlayerTemplates"
              style="max-height: 300px"
              class="mt-5 d-flex justify-content-center align-items-center dataTable__loading"
            >
              <CSpinner class="my-3" color="primary" />
            </div>
            <ListViewtemplate :templates="unlayerTemplates" v-else />
          </div>
        </CCol> -->
      </CRow>
    </CCol>

    <CModal :title="modalData.name" color="secundary" :show.sync="modal" size="xl">
      <iframe
        :class="{ 'brightness-05': deleteModal }"
        :src="modalData.htmlFileUri"
        ref="iframeModal"
        width="100%"
        height="700px"
        frameborder="0"
      ></iframe>

      <template #footer>
        <div>
          <CButton :disabled="loading" v-if="routeParams" class="m-3" color="primary" @click="createCopyTemplate(modalData)">
            {{ $t('general.SELECT_TEMPLATE') }}
          </CButton>

          <div v-else>
            <CButton class="mr-2 p-2" v-if="modalData.emailTemplateId" color="danger" @click.stop="toggleDeleteModal()">
              {{ $t('templates.email.list.delete') }}
            </CButton>
            <CButton
              class="p-2 px-4"
              :disabled="loading"
              v-show="modalData.emailTemplateId || modalData.isDefaultTemplate"
              color="primary"
              @click="goEdit(modalData)"
              >{{ $t('templates.email.list.edit') }}</CButton
            >
          </div>
        </div>
        <transition name="fade">
          <MenssageAlert :messages="messagesSend" />
        </transition>
      </template>
      <transition name="fade" v-if="deleteModal">
        <div class="dataTable__popUp popUp popUp--top centralize-popup" @click.stop.stop>
          <div class="popUp__body shadow-sm">
            <ConfirmationDelete
              :title="$t('templates.email.list.deleteModal.title')"
              :description="$t('templates.email.list.deleteModal.description')"
              :loadingConfirm="isLoadingDeleteModalConfirm"
              @cancel="toggleDeleteModal"
              @confirm="confirmDelete"
            />
          </div>
        </div>
      </transition>
    </CModal>
  </CRow>
</template>

<script>
import { themesEmails, LayoutEmails } from '@/endPointMocks.js'
import ListViewtemplate from '../components/ListViewTemplates'
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import ConfirmationDelete from '@/components/ConfirmationDelete'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '../constants'

export default {
  name: 'newTemplateList',
  components: {
    ListViewtemplate,
    MenssageAlert,
    ConfirmationDelete,
  },

  data() {
    return {
      messages: [],
      messagesSend: [],
      loading: false,
      loadingMyTemplates: false,
      loadingUnlayerTemplates: false,
      loadingModelTemplates: false,
      modelTemplates: [],
      myTemplates: [],
      defaultTemplates: [],
      unlayerTemplates: [],
      themes: themesEmails(),
      layout: LayoutEmails(),
      modal: false,
      modalData: {},
      options: [
        {
          name: this.$t('templates.email.new-template-list.new.import-html'),
          thumbnailUri: require('@/assets/imgs/Import_HTML.png'),
          alwaysVisible: true,
          link: { name: 'import-html', params: this.$route.params, hash: this.$route.hash },
        },
        {
          name: this.$t('templates.email.new-template-list.new.builder-html'),
          thumbnailUri: require('@/assets/imgs/code.png'),
          alwaysVisible: true,
          link: { name: 'unlayer', params: this.$route.params, hash: this.$route.hash },
        },
        {
          name: this.$t('templates.new-template-list.new.simple-text'),
          thumbnailUri: require('@/assets/imgs/simple-text.png'),
          alwaysVisible: false,
          link: {
            name: 'create-simple-text',
            params: { ...this.$route.params, simpleText: true, hash: this.$route.hash },
          },
        },
      ],
      deleteModal: false,
      isLoadingDeleteModalConfirm: false,
    }
  },

  computed: {
    isDestinationTypeCampaign() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN == this.$route.params.dynamicDestinationType
    },

    isDestinationTypeWorkflow() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW == this.$route.params.dynamicDestinationType
    },

    routeParams() {
      return this.$route.params.dynamicId ? this.$route.params : null
    },

    cantCreateSub() {
      return this.$store.getters['auth/subOrganizationMaxCount']
    },

    hasHTMLBuilderData() {
      if (!this.item?.htmlBuilderData) return false

      return Object.keys(this.item.htmlBuilderData).length !== 0
    },

    isEmailSelection() {
      return this.$route.params.dynamicId ? true : false
    },
  },

  mounted() {
    if (this.$route.params.messages) this.messages = this.$route.params.messages

    this.getData({
      page: 1,
      count: 50,
      sort: 2,
      SortField: 'updatedDateTime',
    })
    //this.getUnlayerData()

    this.$root.$on('open-modal-preview', (item) => {
      this.openModal(item)
    })
  },

  methods: {
    createCopyTemplate(model) {
      this.loading = true
      let formData = new FormData()
      this.messagesSend = []

      /* TODO: REMOVER MOCK TESTES const TEMPLATE = {
        contentType: 2, // 1 = simples text || 2 = html
        emailTemplateId: 'fc088702-29e5-48ed-9bda-14ac7a9bfab1',
        name: 'teste_349f99f8edc34b54b9cb4b4f8d4ccbe8',
        thumbnailUri:
          'https://multichannel-sendit.multichannel-dev.sendit.pt/services/template/email/static/fc088702-29e5-48ed-9bda-14ac7a9bfab1/thumbnail.jpg',
        htmlFileUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/fc088702-29e5-48ed-9bda-14ac7a9bfab1/index.html`,
      }
      this.handleCopyRedirect(TEMPLATE)
      return */
      try {
        this.isDestinationTypeCampaign && formData.append('campaignId', this.$route.params.dynamicId)
        this.isDestinationTypeWorkflow && formData.append('workflowId', this.$route.params.dynamicId)
        formData.append('ParentTemplateId', model.emailTemplateId)
      } catch (error) {
        this.messagesSend.push({
          status: 'danger',
          text: error || 'ERROR',
        })
      }
      let organizationId = this.$store.state.auth.organizationId

      services
        .sendTemplatesEmail(organizationId, formData)
        .then((result) => {
          this.messagesSend.push({
            status: 'success',
            text: 'Next Step',
          })

          const TEMPLATE = result.data.data

          this.handleCopyRedirect(TEMPLATE)
        })
        .catch((error) => {
          this.messagesSend.push({
            status: 'danger',
            text: error.response.data.message || error || 'ERROR',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleCopyRedirect(template) {
      let redirectRouteName

      const routerPushParams = {
        messages: [
          {
            status: 'success',
            text: '',
          },
        ],
        template: {
          contentType: 2, // 1 = simples text || 2 = html
          id: template.emailTemplateId,
          name: template.name,
          thumbnailUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${template.emailTemplateId}/thumbnail.jpg`,
          htmlFileUri: `${this.$configs.VUE_APP_ROOT_API}template/email/static/${template.emailTemplateId}/index.html`,
        },
      }

      if (this.isDestinationTypeCampaign) {
        redirectRouteName = 'campaignCreator'
        routerPushParams.messages[0].text = this.$t('templates.messages.template-saved-end-add-campaign', [template.name])
        routerPushParams.campaignId = this.$route.params.dynamicId
        routerPushParams.indexChannel = this.$route.params.dynamicIndex
      }

      if (this.isDestinationTypeWorkflow) {
        redirectRouteName = 'automationWorkflow'
        routerPushParams.messages[0].text = this.$t('templates.messages.template-saved-end-add-automation', [template.name])
        routerPushParams.workflowId = this.$route.params.dynamicId
        routerPushParams.indexStep = this.$route.params.dynamicIndex
        routerPushParams.template.isUnlayer = !!template.htmlBuilderData
      }

      this.$router.push({
        name: redirectRouteName,
        params: routerPushParams,
        hash: this.$route.hash,
      })
    },

    openModal(item) {
      this.modal = true
      this.modalData = item
    },

    back() {
      if (this.isDestinationTypeCampaign) {
        this.$router.push({
          name: 'campaignCreator',
          params: {
            campaignId: this.$route.params.dynamicId,
          },
        })
        return
      }

      if (this.isDestinationTypeWorkflow) {
        this.$router.push({
          name: 'automationWorkflow',
          params: {
            workflowId: this.$route.params.dynamicId,
          },
          hash: this.$route.hash,
        })
        return
      }

      this.$router.push({ name: 'template-emails' })
    },

    getData(data) {
      this.loadingMyTemplates = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .templatesEmail(organizationId, { params: data })
        .then((templates) => {
          this.myTemplates = templates.data.data.templates
          // na listagem de defaultTemplates é criada uma propriedade para diferenciar dos myTemplates
          if (templates?.data?.data?.defaultTemplates) {
            this.defaultTemplates = templates.data.data.defaultTemplates.map((elm) => {
              elm.isDefaultTemplate = true
              return elm
            })
          }
        })
        .catch(() => {
          this.myTemplates = []
        })
        .finally(() => {
          this.loadingMyTemplates = false
        })
    },

    getUnlayerData() {
      this.loadingUnlayerTemplates = true
      services
        .getUnlayerTemplates()
        .then((templates) => {
          this.unlayerTemplates = templates.data.data
        })
        .catch(() => {
          this.unlayerTemplates = []
        })
        .finally(() => {
          this.loadingUnlayerTemplates = false
        })
    },

    goEdit(item) {
      if (item.isDefaultTemplate) {
        return this.$router.push({
          name: 'plan-unlayer',
          params: { templatePlanId: item.id },
          hash: this.$route.hash,
        })
      }

      if (!item?.emailTemplateId) return

      const hasHTMLBuilderData = item.htmlBuilderData && Object.keys(item.htmlBuilderData).length !== 0

      if (hasHTMLBuilderData) {
        if (item.isDefaultTemplate) {
          return this.$router.push({
            name: 'plan-unlayer',
            params: { templatePlanId: item.emailTemplateId },
            hash: this.$route.hash,
          })
        }
        return this.$router.push({
          name: 'unlayer',
          params: { templateId: item.emailTemplateId },
          hash: this.$route.hash,
        })
      }

      this.$router.push({
        name: 'edit-template-html',
        params: { id: item.emailTemplateId },
        hash: this.$route.hash,
      })
    },

    toggleDeleteModal() {
      this.deleteModal = !this.deleteModal
    },

    async confirmDelete() {
      try {
        this.isLoadingDeleteModalConfirm = true
        const organizationId = this.$route.params.organizationId
        await services.deleteTemplatesEmail(organizationId, { data: [this.modalData.emailTemplateId] })
        this.getData({
          page: 1,
          count: 50,
          sort: 2,
          SortField: 'updatedDateTime',
        })
      } catch ({ response }) {
        this.messages.push({
          status: 'danger',
          text: response?.data?.message,
        })
      } finally {
        this.modal = false
        this.deleteModal = false
        this.isLoadingDeleteModalConfirm = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.newTemplateLists {
  h4 {
    border-bottom: 1px solid var(--gray-300);
    line-height: 2.5rem;
    margin-bottom: 2rem;
  }
}

.centralize-popup {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.brightness-05 {
  filter: brightness(0.5);
}
</style>
